import { useEffect, useState } from 'react';
import { requestForToken } from '../utils/firebase';
import { notificationsApi } from '../services/api';

export const usePushNotifications = () => {
  const [notificationToken, setNotificationToken] = useState<string | null>(null);

  const subscribeToNotifications = () => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
      return Promise.resolve('default' as NotificationPermission);
    }

    return Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        requestForToken().then((token) => {
          if (token) {
            setNotificationToken(token);
            // Sync with backend
            notificationsApi.subscribe(token, navigator.userAgent).catch(e => console.error(e));
          }
        });
      }
      return permission;
    }).catch((error) => {
      console.error('Error enabling push notifications:', error);
      return 'default' as NotificationPermission;
    });
  };

  useEffect(() => {
    // Check if permission already granted and silently refresh token
    const checkPermissionAndRefresh = async () => {
      if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
        const token = await requestForToken();
        if (token) {
          setNotificationToken(token);
          // Silently sync with backend in case token changed
          try {
            await notificationsApi.subscribe(token, navigator.userAgent);
          } catch (e) {
            console.warn('Silent token sync failed', e);
          }
        }
      }
    };
    
    checkPermissionAndRefresh();
  }, []);

  const unsubscribeFromNotifications = async () => {
    try {
      const token = await requestForToken();
      if (token) {
        await notificationsApi.unsubscribe(token);
        setNotificationToken(null);
      }
    } catch (error) {
      console.error('Error disabling push notifications:', error);
    }
  };


  return { subscribeToNotifications, unsubscribeFromNotifications, notificationToken };
};
